<template>
  <div class="add_warp">
    <div>
      <div class="courseInfo">课程信息</div>
      <formCustom
        :data="searchHeaders"
        :bindProps="{ 'label-width': '124px', 'scroll-to-error': true }"
        :ruleForm.sync="classruleForm"
        :formRef.sync="formRef"
      >
      </formCustom>
    </div>
    <div v-if="showCate">
      <div class="courseInfo">商品参数</div>
      <formCustom
        :data="commodities"
        :bindProps="{ 'label-width': '124px', 'scroll-to-error': true }"
        :ruleForm.sync="commoditiesRuleForm"
        :formRef.sync="commoditiesFormRef"
      >
      </formCustom>
    </div>
    <div class="from_item_con">
      <!-- <el-button type="primary" @click="submitForm(2)">保存草稿</el-button> -->
      <el-button type="primary" @click="submitForm(1)" style='width:150px;'>提交</el-button>
    </div>
    <previewData v-model="classruleForm"></previewData>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { deepClone } from "lodash-unified";
import formCustom from "../../../components/useTable/customForm";
import addCourseSelect from "../../../components/virtualizedSelect/addCourseSelect.vue";
import uploadImage from "./components/uploadImg/uploadImg.vue";
import previewData from "./components/previewData/previewData.vue";
import searchCascader from "../../../components/searchCascader/searchCascader.vue";
import { strLength } from "@/utils/index";
import {fakeListData} from '@/utils/fakeData.js'
const formProps = {
  style: {
    marginBottom: "0",
    marginRight: "16px",
  },
};
export default {
  components: {
    formCustom,
    addCourseSelect,
    uploadImage,
    previewData,
    searchCascader,
  },
  data() {
    return {
      f_cat_id: 381003,
      selDisable:false,
      classruleForm: {
        product_id: "",
        cat_id: [],
        title: "",
        sub_title: "",
        sale_price: "",
        desc: "",
        descimg: [],
        head_imgs: [],
      },
      commoditiesRuleForm: {},
      formRef: {},
      commoditiesFormRef: {},
      isHttpFlag: false,
      searchHeaders: [
        {
          label: "选择课程",
          Component: addCourseSelect,
          prop: "product_id",
          defaultValue: "",
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message: "请选择课程",
            },
            ...formProps,
          },
          componentProps: {
            // clearable:true,
            style: {
              width: "240px",
            },
            placeholder: "选择课程",
            selectProps: {
              label: "title",
              value: "id",
              disable:'disabled'
            },
            filterable: true,
            disable:this.selDisable,
            httpRequest: async (params) => {
              let res = await this.getProductSelect(params);
              let data = {
                total: res.count,
                data: res.data,
              };
              this.classruleForm.product_id = this.classruleForm.product_id
                ? this.classruleForm.product_id
                : data?.data[0]?.product_id;
              return data;
            },
          },
          afterSlot: () => (
            <span style="font-size:12px;margin-left:8px;">
              <span style="color:#666;margin-right:4px;">
                视频号课程需要和您已创建的课程（必须已上架）进行关联
              </span>
              <span style="color:red;">
                注意：小店商品与小程序课程是一对一关系
              </span>
            </span>
          ),
        },
        {
          label: "课程分类",
          prop: "cat_id",
          Component: searchCascader,
          componentProps: {
            placeholder: "请选择分类",
            style: {
              width: "240px",
            },
            selectProps: {
              label: "name",
              value: "cat_id",
              lazy: true,
              lazyLoad: async (node, resolve) => {
                const { level } = node;
                let res = [];
                if (level == 0) {
                  res = await this.getCategory({ id: 381003 });
                } else {
                  res = await this.getCategory({ id: node.value });
                }
                res = res.map((item) => {
                  return {
                    ...item,
                    leaf: level >= 1,
                  };
                });
                resolve(res);
              },
            },
            httpRequest: async (params) => {
              let res = await this.getCategory(params);
              return res;
            },
            // filterable,
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message: "请选择分类",
            },
            ...formProps,
          },
        },
        {
          label: "课程标题",
          prop: "title",
          Component: "ElInput",
          defaultValue: "",
          componentProps: {
            placeholder: "请输入课程标题",
            style: {
              width: "240px",
            },
            maxLength: 60,
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",

              validator: (rule, value, callback) => {
                if (value === "") {
                  callback(new Error("请输入课程标题"));
                }
                const len = strLength(value);
                if (len < 3) {
                  callback(new Error("课程标题需3个字符以上"));
                }
                callback();
              },
            },
          },
        },
        {
          label: "课程副标题",
          prop: "sub_title",
          Component: "ElInput",
          defaultValue: "",
          componentProps: {
            placeholder: "请输入课程副标题",
            style: {
              width: "240px",
            },
            maxLength: 18,
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",

              validator: (rule, value, callback) => {
                if (value === "") {
                  callback(new Error("请输入课程副标题"));
                }
              },
            },
          },
        },
        {
          label: "课程售价",
          prop: "sale_price",
          Component: "ElInput",
          defaultValue: "",
          componentProps: {
            placeholder: "支持小数点后两位",
            style: {
              width: "240px",
            },
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message: "请输入课程售价",
            },
          },
          afterSlot: () => (
            <span style="font-size:12px;margin-left:8px;">
              <span style="color:#666;margin-right:4px;">
                元
              </span>
            </span>
          ),
        },
        {
          label: "封面主图",
          prop: "head_imgs",
          Component: uploadImage,
          defaultValue: "",
          beforeSlot: () => (
            <div style="font-size:12px; color:#666;">
              请至少上传3张不同图片最多上传9张，单张10MB以内，比例1:1最佳，以保证审核通过。
            </div>
          ),
          componentProps: {
            // placeholder: "支持小数点后两位，免费则输入0",
            style: {
              width: "240px",
            },
            limit: 9,
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              validator: (rule, value, callback) => {
                if (!value.length) {
                  callback(new Error("请上传封面主图"));
                }
                if (value.length < 3) {
                  callback(new Error("封面主图至少上传3张"));
                }
              },
            },
          },
        },
        {
          label: "详情描述",
          prop: "desc",
          Component: "ElInput",
          defaultValue: "",
          componentProps: {
            placeholder: "请输入",
            style: {
              width: "240px",
            },
            type: "textarea",
            rows: 8,
          },
          formProps: {
            rules: {
              required: true,
            },
          },
        },
        {
          label: "详情图片",
          prop: "descimg",
          Component: uploadImage,
          defaultValue: "",
          beforeSlot: () => (
            <div style="font-size:12px; color:#666;">
              单张图片需限制在10M以内，
            </div>
          ),
          componentProps: {
            // placeholder: "支持小数点后两位，免费则输入0",
            style: {
              width: "240px",
            },
            limit: 20,
          },
          formProps: {
            rules: {
              required: true,
            },
          },
        },
      ],
      commodities: [],
      commoditiesData: [],
      commoditiesValue: [],
      commoditiesValueEdit:[],
      showCate: false,
      class_id: null,
      isFirst: true,
    };
  },

  created() {
    this.class_id = this.$route.params.id ? this.$route.params.id : null;
    if (this.class_id) {
      this.getEditClassData();
    }
  },
  methods: {
    ...mapActions("wxVideo", [
      "videoClassCategory",
      "videoClassProduct",
      "videoClassCategoryDetail",
      "videoClassCreate",
      "videoClassInfo",
      "videoClassUpdate",
    ]),
    async getProductSelect(params) {
      let res = await this.videoClassProduct({ ...params });
      return res;
    },
    async getCategory(params) {
      let res = await this.videoClassCategory({ ...params });
      return res;
    },
    async getCategoryDetails(params) {
      let res = await this.videoClassCategoryDetail({ ...params });
      let value = res.attr.product_attr_list;
      this.commodities = [];
      this.commoditiesData = [];
      value.forEach((item) => {
        if (item.is_required) {
          this.commoditiesData.push(item);
        }
      });
      this.getCommodiData(this.commoditiesData);
    },
    getCommodiData(array) {
      let commoditiesArr = [];
      array.forEach((item, index) => {
        if (!this.class_id) {
          let keys = {
            attr_key: item.name,
            attr_value: "",
          };
          
          this.commoditiesValue.push(keys);
        }else{
            let ind = this.commoditiesValueEdit.findIndex(ite => ite.attr_key === item.name);
            if (ind !== -1) {
              this.commoditiesValue.splice(index, 0, this.commoditiesValueEdit[ind]);
              this.commoditiesRuleForm = this.toObject(this.commoditiesValue, 1);
            }else{
              let keys = {
                attr_key: item.name,
                attr_value: "",
              };
              this.commoditiesValue.push(keys);
            }
     
        }
        let data = {};
        if (item.type == "select_one") {
          data = {
            label: item.name,
            prop: "attr_key" + index,
            Component: "ElSelect",
            defaultValue: "",
            componentProps: {
              clearable: true,
              placeholder: `请选择${item.name}`,
              style: {
                width: "240px",
              },
            },
            componentSlots: {
              default: () => {
                return item.value.split(";").map((item) => {
                  return (
                    <el-option value={item} label={item} key={item}></el-option>
                  );
                });
              },
            },
            formProps: {
              rules: {
                required: item.is_required,
                trigger: "blur",
                message: `请选择${item.name}`,
              },
            },
          };
        } else {
          data = {
            label: item.name,
            prop: "attr_key" + index,
            Component: "ElInput",
            defaultValue: "",
            componentProps: {
              placeholder: `请输入${item.name}`,
              style: {
                width: "240px",
              },
            },
            formProps: {
              rules: {
                required: item.is_required,
                trigger: "blur",
                message: `请输入${item.name}`,
              },
            },
          };
        }
        commoditiesArr.push(data);
      });
     if(!this.isFirst && this.class_id){
      this.commoditiesRuleForm = this.toObject(this.commoditiesData)
     }
      this.commodities = commoditiesArr;
      this.isFirst = false

      this.$nextTick(() => {
        this.showCate = true;
        
      });
    },

    toObject(pairs,type) {
      return pairs.reduce(
        (obj, item, cindex) => (
          (obj["attr_key" + cindex] = type==1?item.attr_value:""), obj
        ),
        {}
      );
    },
    submitForm(type) {
      let attrs = this.commoditiesValue.reduce((arr = [], item, index) => {
        const obj = {
          attr_key: item.attr_key,
          attr_value: this.commoditiesRuleForm["attr_key" + index],
        };
        if(obj.attr_value != undefined){
          arr.push(obj);
        }
        return arr;
      }, []);
      let keys = { ...this.classruleForm };
      keys.cat_id = [...[this.f_cat_id], ...keys.cat_id];
      let data = { ...keys, ...{ attrs: attrs,listing:type } };
      this.submit(data);
    },
    async submit(data) {
      if (this.class_id) {
        await this.videoClassUpdate({ ...data, ...{ id: this.class_id } });
      } else {
        await this.videoClassCreate(data);
      }
      this.$message({
        type: "success",
        message: "保存成功",
      });
      this.$router.go(-1);
    },

    async getEditClassData() {
      let res = await this.videoClassInfo({ id: this.class_id });
      let data = { ...res };
      data.desc = data.desc_info.desc;
      data.descimg = data.desc_info.imgs;
      data.cat_id.shift();
      this.selDisable = data.status ==0?false:true
      delete data.desc_info;
      this.commoditiesValueEdit = res.attrs;
      for (const key in this.classruleForm) {
        if (data[key]) {
          this.classruleForm[key] = data[key];
        }
      }
    },
  },
  watch: {
    "classruleForm.cat_id"(news) {
      if (news.length) {
        if (!this.isFirst) {
          this.showCate = false
          // for (const key in this.commoditiesRuleForm) {
          //   this.$set(this.commoditiesRuleForm,key,'')
          // }
        }
        this.getCategoryDetails({ id: news[news.length - 1] });
      }
    },
  },
};
</script>

<style lang="less">
.courseInfo {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}
.from_item_con {
  width: 100%;
  display: flex;
  justify-content: center;
}
.add_warp {
  width: 100%;
  position: relative;
}
</style>